import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const ViewGenericAccountKeyDetailsWrapper = styled.div`
  .semi-header-container {
    padding: 0 16px 16px 16px;

    ${responsive.MOBILE`
      flex-direction: column;
      padding: 0 8px 16px 8px;
    `}
  }
  .number-of-accounts {
    display: flex;
    gap: 5px;
  }
  .copy-registration-code,
  .clipboard-value {
    width: auto;
    margin-top: 3px;
  }
  .copy-button {
    margin-left: 10px;
  }
`;
